export default __webpack_public_path__ + "static/media/deleteIcon.dc0c08de.svg";